import React from 'react';
import TableBody from '@mui/material/TableBody'
import { TableRowStyled, TableCellStyled } from "../styling/tableStyles";

export default function TableNoSortBody(props) {
  const { tabledata, cheads } = props;
  
  return (
  	<>
      <TableBody>
        {tabledata.map((trow, r) => {
          return (
            <TableRowStyled key={"r"+r} sx={trow.sx}>
              {cheads.map((hc) => {
                if (!hc.invisible && hc.id !== null) {
                  const sx = hc.component === "th" ? {fontWeight:500+"!important"} : {}
                  return (
                    <TableCellStyled sx={sx} key={hc.id} >
                      {trow[hc.id].toLocaleString("en")}
                    </TableCellStyled>
                  )
                }
              })}
            </TableRowStyled>
          )
        })}
      </TableBody>
  	</>
  )
}